import { render } from "./createProductForm.vue?vue&type=template&id=13a8ce7d"
import script from "./createProductForm.vue?vue&type=script&lang=js"
export * from "./createProductForm.vue?vue&type=script&lang=js"

import exportComponent from "C:\\xampp\\htdocs\\bmac\\ims-web-api\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__